module.exports = __webpack_public_path__ + "static/media/yoda.bdc63605.png";